export const comments_5627994 = {"data":{"data":[],"links":{}}}